module.exports = __webpack_public_path__ + "img/9.70369d21.jpg";